import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconUnitArea = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 11,
	height: 11,
	viewBox: "0 0 11 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0 1.22222V9.77778C0 10.4518 0.548167 11 1.22222 11H9.77778C10.4518 11 11 10.4518 11 9.77778V1.22222C11 0.548167 10.4518 0 9.77778 0H1.22222C0.548167 0 0 0.548167 0 1.22222ZM9.779 9.77778H1.22222V1.22222H9.77778L9.779 9.77778Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.33322 5.50001H8.55545V2.44446H5.49989V3.66668H7.33322V5.50001ZM5.49989 7.33335H3.66656V5.50001H2.44434V8.55557H5.49989V7.33335Z",
		fill: "currentColor"
	})]
});
export default SvgIconUnitArea;
